const messages = {
    // Página de Nómina de Proveedores (US #1803 rename)
    providerPayroll: 'Nómina de proveedores',
    providerPayrollSubtitle:
        'Administre el borrador actual y revise los periodos de nómina anteriores de los proveedores externos.',
    newPayrollPeriod: 'Nuevo periodo de nómina',
    createPayrollPeriod: 'Crear periodo de nómina',
    providerPayrollPeriodCreated: 'Periodo de nómina del proveedor creado exitosamente',
    currentDraft: 'BORRADOR ACTUAL',
    pastPeriods: 'Periodos anteriores',
    paymentStatusCounts: 'Conteos de estado de pagos',
    draftCount: 'Borrador',
    reviewCount: 'Revisión',
    printedCount: 'Impreso',
    noPayrollPeriods: 'Aún no hay periodos de nómina',
    noPayrollPeriodsHint:
        'Cree el primer periodo de nómina para comenzar a registrar los pagos del proveedor.',
    errorLoadingProviderPayroll: 'Error al cargar la nómina de proveedores',
    unauthorizedProviderPayroll: 'Usted no tiene autorización para ver la Nómina de proveedores',
    unauthorizedCreatePayrollPeriod: 'Usted no tiene autorización para crear un periodo de nómina',
    // Página de lista de cheques en borrador
    viewDraftChecks: 'Ver cheques en borrador',
    loading: 'Cargando',
    errorLoadingDraftChecks: 'Error al cargar los cheques en borrador',
    backToPayrollPeriods: 'Volver a periodos de nómina',
    draftChecklist: 'Lista de cheques en borrador',
    draftChecklistSubtitle:
        'Revise y gestione los cheques incluidos en este borrador del periodo de nómina.',
    addOneOffCheckUnavailable: 'La creación de cheques únicos aún no está disponible',
    addOneOffCheck: 'Agregar cheque único',
    draftSummary: 'Resumen del borrador',
    checks: 'cheques',
    totalAmount: 'Monto total',
    noDraftChecks: 'Aún no hay cheques en borrador',
    noDraftChecksHint:
        'Los cheques generados automáticamente aparecerán aquí. También puede agregar cheques únicos.',
    draftChecklistTableLabel: 'Tabla de cheques en borrador',
    unauthorizedDraftChecks: 'Usted no tiene autorización para ver los cheques en borrador',
    // Acciones de fila de cheques en borrador (#1695)
    editCheck: 'Editar cheque',
    deleteCheck: 'Eliminar cheque',
    sendToReview: 'Enviar a revisión',
    // Panel lateral de edición de cheque en borrador
    editDraftCheck: 'Editar cheque en borrador',
    editDraftCheckDescription: 'Actualice el monto o el memo de este cheque en borrador.',
    checkUpdatedSuccessfully: 'Cheque actualizado exitosamente',
    errorUpdatingCheck: 'Error al actualizar el cheque',
    // Confirmación de eliminación
    deleteCheckTitle: 'Eliminar cheque en borrador',
    deleteCheckText:
        '¿Está seguro de que desea eliminar este cheque? Esta acción no se puede deshacer.',
    checkDeletedSuccessfully: 'Cheque eliminado exitosamente',
    errorDeletingCheck: 'Error al eliminar el cheque',
    // Confirmación de envío a revisión
    sendToReviewTitle: 'Enviar cheque a revisión',
    sendToReviewText:
        'Este cheque pasará del estado Borrador al estado Revisión. ¿Desea continuar?',
    checkSentToReviewSuccessfully: 'Cheque enviado a revisión exitosamente',
    errorSendingCheckToReview: 'Error al enviar el cheque a revisión',
    unauthorizedOneOffCheck: 'Usted no tiene autorización para crear cheques únicos',
    // Chip "Devuelto para edición" — se muestra en la fila del borrador cuando el cheque fue devuelto desde Revisión (#1698)
    returnedForEdits: 'Devuelto para edición',
    // Modal de cheque único (Story #1697)
    addOneOffCheckTitle: 'Agregar cheque único',
    addOneOffCheckDescription:
        'Cree un cheque único para un proveedor existente o un nuevo proveedor en línea.',
    providerType: 'Tipo de proveedor',
    providerPathExisting: 'Proveedor existente',
    providerPathInline: 'Nuevo proveedor en línea',
    searchProvider: 'Proveedor',
    searchProviderPlaceholder: 'Escriba para buscar proveedores...',
    searchProviderResults: 'Resultados de búsqueda de proveedores',
    clearSelection: 'Limpiar selección',
    inlineProviderName: 'Nombre del proveedor',
    inlineProviderCategory: 'Categoría del proveedor',
    selectCategory: '- Seleccione categoría -',
    duplicateProviderWarning: 'Ya existe un proveedor similar',
    oneOffCheckCreatedSuccessfully: 'Cheque único creado exitosamente',
    selectProvider: 'Por favor seleccione un proveedor',
    fieldRequired: 'Este campo es requerido',
    maxLength200: 'Debe tener 200 caracteres o menos',
    // Envío masivo a revisión (#1696 / #1762)
    selected: 'seleccionados',
    selectAllChecks: 'Seleccionar todos los cheques',
    selectCheck: 'Seleccionar cheque',
    bulkSendToReview: 'Enviar seleccionados a Revisión',
    bulkSendToReviewTitle: 'Enviar cheques seleccionados a revisión',
    bulkSendToReviewText:
        'Los cheques seleccionados pasarán del estado Borrador al estado Revisión. ¿Desea continuar?',
    bulkBarAriaLabel: 'Barra de acciones masivas',
    // Resultados de envío masivo a revisión (#1762)
    bulkSentToReviewCount: '{count} cheques enviados a revisión exitosamente',
    bulkPartialFailureTitle: 'Algunos cheques no pudieron enviarse a revisión',
    bulkPartialFailureMessage:
        '{succeeded} de {total} cheques enviados a revisión. {failed} no pudieron procesarse y permanecen seleccionados para reintento.',
    bulkFullFailureTitle: 'Ningún cheque pudo enviarse a revisión',
    bulkFullFailureMessage:
        'Los {count} cheques seleccionados no pudieron enviarse a revisión. Permanecen seleccionados para reintento.',
    // Página de cola de revisión (Story #1698)
    viewReviewChecks: 'Ver cheques en revisión',
    errorLoadingReviewChecks: 'Error al cargar los cheques en revisión',
    reviewChecklist: 'Lista de cheques en revisión',
    reviewChecklistSubtitle:
        'Cheques enviados a revisión. Devuelva los cheques no impresos al borrador si se necesitan ediciones.',
    reviewSummary: 'Resumen de revisión',
    noReviewChecks: 'No hay cheques en revisión',
    noReviewChecksHint: 'Los cheques enviados a revisión desde el borrador aparecerán aquí.',
    reviewChecklistTableLabel: 'Tabla de cheques en revisión',
    unauthorizedReviewChecks: 'Usted no tiene autorización para ver los cheques en revisión',
    checkNumber: 'Cheque #',
    printed: 'Impreso',
    // Acción Devolver al borrador (PAC.12.06)
    returnToDraft: 'Devolver al borrador',
    returnToDraftTitle: 'Devolver cheque al borrador',
    returnToDraftText:
        'Este cheque pasará del estado Revisión al Borrador para su edición. ¿Desea continuar?',
    checkReturnedToDraftSuccessfully: 'Cheque devuelto al borrador exitosamente',
    errorReturningCheckToDraft: 'Error al devolver el cheque al borrador',
    // Texto del tooltip para la acción deshabilitada en cheques impresos
    printedCannotBeReturned: 'Los cheques impresos no pueden devolverse.',
    // Imprimir cheques seleccionados — barra de acción de selección (#1699)
    selectionActionBarAriaLabel: 'Barra de acción de selección',
    printSelectedChecks: 'Imprimir cheques seleccionados',
    printedCheckCannotBeReprinted:
        'Los cheques ya impresos no pueden reimprimirse desde la vista previa.',
    unauthorizedPrintPreview:
        'Usted no tiene autorización para generar una vista previa de nómina.',
    // Imprimir cheques seleccionados — diálogo (#1699)
    checkNumbersAssignedRange: 'Números de cheque que se asignarán: {from} \u2013 {to}',
    payDateRequired: 'La fecha de pago es requerida.',
    payDateTooFarFuture: 'La fecha de pago no puede ser más de 1 año en el futuro.',
    startingCheckNumberRequired: 'El número de cheque inicial es requerido.',
    startingCheckNumberOutOfRange: 'El número de cheque inicial debe estar entre 1 y 9,999,999.',
    generating: 'Generando...',
    generatePdf: 'Generar PDF',
    payDateLabel: 'Fecha de pago',
    payDateHelp: 'Fecha que aparecerá en cada cheque impreso.',
    startingCheckNumberLabel: 'Número de cheque inicial',
    startingCheckNumberHelp: 'Primer número a asignar a la selección.',
    startingCheckNumberPlaceholder: 'ej. 1042',
    mutationSafeNotice:
        'Generar el PDF no marcará estos cheques como impresos. Confirmará después de una impresión exitosa.',
    errorGeneratingPdf: 'No se pudo generar el PDF.',
    errorGeneratingPdfDetail: 'No se modificaron cheques. Por favor, reintente.',
    retry: 'Reintentar',
    rangeLabel: 'Rango',
    required: 'requerido',
    // Diálogo de espera de confirmación (#1700)
    awaitingConfirmationTitle: '¿Los cheques se imprimieron correctamente?',
    awaitingConfirmationBody:
        'El PDF ha sido generado. Inspeccione la impresión y confirme para que el sistema pueda registrar estos cheques como impresos.',
    reDownloadPdf: 'Volver a descargar PDF',
    yesMarkAsPrinted: 'Sí, marcar como impreso',
    confirming: 'Confirmando...',
    checksConfirmedAsPrinted: 'Cheques confirmados como impresos.',
    errorConfirmingPrinted: 'No se pudieron confirmar los cheques como impresos.',
    printPreviewClosedNoChanges: 'Vista previa cerrada. No se modificaron datos.',
    // Panel Cerrar Periodo (US #1701)
    closePeriod: 'Cerrar periodo',
    closingPeriod: 'Cerrando...',
    closePeriodTitle: 'Cerrar periodo de nómina',
    closePeriodText:
        'Esto cerrará permanentemente el periodo de nómina. No se permitirán más cambios. ¿Desea continuar?',
    closePeriodSuccess: 'Periodo de nómina cerrado exitosamente',
    errorClosingPeriod: 'Error al cerrar el periodo de nómina',
    closePeriodBlockersTitle: 'Bloqueos de liquidación',
    closePeriodBlockersDraftSingular: '1 cheque permanece en Borrador',
    closePeriodBlockersDraftPlural: '{n} cheques permanecen en Borrador',
    closePeriodBlockersReviewSingular: '1 cheque en Revisión no ha sido impreso',
    closePeriodBlockersReviewPlural: '{n} cheques en Revisión no han sido impresos',
    closePeriodEligible: 'Todos los cheques están liquidados. El periodo está listo para cerrarse.',
    unauthorizedClosePeriod: 'Usted no tiene autorización para cerrar este periodo de nómina',
};

export default messages;
